module.exports = __webpack_public_path__ + "static/media/icon-home-default.d73adea7.svg";